import React from "react";
import {
  getRfiTypeLabelFromItem,
  rfiTypeLabelLooksDiligent,
} from "../../utils/myRfiGridRowMapper";

/**
 * Type column for get_rfis / Provider get_rfis rows: uses API `type` when present (included in server search),
 * with legacy fallback from `is_global_template`. Column is not sortable in the UI.
 */
export default function RfiTypeBadge({ item }) {
  const label = getRfiTypeLabelFromItem(item);
  const diligent = rfiTypeLabelLooksDiligent(label);
  if (diligent) {
    return (
      <span className="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10">
        {label}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded-md bg-slate-50 px-2 py-1 text-xs font-medium text-slate-700 ring-1 ring-inset ring-slate-600/10">
      {label}
    </span>
  );
}
